import { useCallback, useEffect } from 'react';

import { useApiPost } from '../../api/Api.hooks';
import { useAppContext } from '../../AppContext';
import { User } from '../../models/User';

export interface SignUpDto {
  email: string;
  firstName: string;
  lastName: string;
  password: string;
}

export default function useSignUp() {
  const { data, isLoading, error, post } = useApiPost<User>('users/sign-up');
  const { logError } = useAppContext();
  useEffect(
    () => void (error && logError('Sign Up Error', error)),
    [error, logError]
  );

  const createUser = useCallback(
    (signUpDto: SignUpDto) => post(signUpDto),
    [post]
  );
  return {
    createdUser: data,
    creatingUser: isLoading,
    createError: error,
    createUser
  };
}
